export const iconFontAwesomeReligionPlaceOfWorship = (
	<i className="fa-solid fa-place-of-worship"></i>
);
